"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleDiagnosticsResource = handleDiagnosticsResource;
const getState_1 = require("../../../app/dist/getState");
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../core/dist");
const dist_3 = require("../../../fs/dist");
const fs = __importStar(require("fs-extra"));
async function handleDiagnosticsResource(root) {
    const registry = new dist_3.ConfigRegistry();
    const state = await (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs, workspaceRoot: root });
    const index = state.index;
    const allIds = new Set(index.documents.keys());
    const issues = [];
    for (const [id, parentId] of index.parent.entries()) {
        if (!allIds.has(parentId)) {
            issues.push({ docId: id, issue: 'broken_parent_id', detail: `parent_id '${parentId}' not found in index` });
        }
    }
    for (const [id, childSet] of index.children.entries()) {
        for (const childId of childSet) {
            if (!allIds.has(childId)) {
                issues.push({ docId: id, issue: 'dangling_child_id', detail: `child_id '${childId}' not found in index` });
            }
        }
    }
    // req scope-coverage: per thread with a locked req + plans, where the plan(s)
    // dropped an Included requirement, cited an Excluded one, or cited a dangling id.
    const reqCoverage = [];
    for (const weave of state.weaves) {
        for (const thread of weave.threads) {
            if (thread.req?.status !== 'locked' || thread.plans.length === 0)
                continue;
            const parsed = (0, dist_2.parseReq)(thread.req.content ?? '');
            const steps = thread.plans.flatMap(p => p.steps ?? []);
            const cov = (0, dist_2.checkReqCoverage)(parsed, steps);
            if (cov.uncovered.length || cov.excludedViolations.length || cov.unknownCitations.length) {
                reqCoverage.push({
                    weaveSlug: weave.id,
                    threadSlug: thread.id,
                    uncovered: cov.uncovered.map(i => i.id),
                    excludedViolations: cov.excludedViolations,
                    unknownCitations: cov.unknownCitations,
                });
            }
        }
    }
    // Step-level cross-plan dangling blockers: a step's blockedBy names a `pl_…` (or legacy
    // "{slug}-plan-NNN") plan that does not exist. This is the standing guarantee behind
    // warn-and-store — the write path stores the edge verbatim, and this recompute is what
    // keeps it from being silent. Mirrors the roadmap's thread-level `dangling_dep`, one layer down.
    const blockedByDangling = [];
    for (const weave of state.weaves) {
        for (const thread of weave.threads) {
            for (const plan of thread.plans) {
                for (const step of plan.steps ?? []) {
                    for (const ref of step.blockedBy ?? []) {
                        if (!(0, dist_2.isPlanIdRef)(ref))
                            continue;
                        const planId = (0, dist_2.planRefId)(ref);
                        const entry = index.documents.get(planId);
                        if (!entry || !entry.exists) {
                            blockedByDangling.push({ weaveSlug: weave.id, threadSlug: thread.id, planId, stepId: step.id, ref });
                        }
                    }
                }
            }
        }
    }
    // Roadmap diagnostics: depends_on cycles, dangling dependency targets, and
    // threads missing thread.md (→ run `loom migrate`). Derived from the same state.
    const roadmapDiagnostics = (0, dist_2.buildRoadmap)(state).diagnostics;
    return {
        contents: [{
                uri: 'loom://diagnostics',
                mimeType: 'application/json',
                text: JSON.stringify({ issueCount: issues.length, issues, reqCoverage, blockedByDangling, roadmap: roadmapDiagnostics }, null, 2),
            }],
    };
}
